import { productCarouselProductCondensedStyles } from "@insite/content-library/Components/ProductCarouselProductCondensed";
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCarouselProductCondensedStyles.container = {
    gap: 4,
    css: css`
        -webkit-box-flex: 1;
        flex-grow: 1;
        width: 100%;
        padding: 2px;
        border: 0.5px solid #f6f6f6;
        &:hover {
            border: 1px solid ${getColor("common.border")};
        }
    `,
};
productCarouselProductCondensedStyles.imageGridItem = {
    width: 2,
    css: css`
        overflow: visible;
        display: flex;
        flex-direction: row;
        padding: 2px;
        flex-basis: 100%;
        max-width: 100%;
        > a {
            img {
                width: 100%;
                height: 60px;
            }
        }
    `,
};

productCarouselProductCondensedStyles.productDetailsGridItem = {
    width: 7,
    css: css`
        flex-direction: column;
        display: none !important;
    `,
};
productCarouselProductCondensedStyles.condensedActionsTemplateGridItem = {
    width: 1,
    css: css`
        overflow: visible;
        display: flex;
        flex-direction: row;
        padding: 2px;
        flex-basis: 8.33333%;
        max-width: 8.33333%;
        position: absolute;
        top: -5px;
        right: 35px;
        background: transparent;
        border: none;
        > button {
            background: transparent;
            border: none;
            padding: 0px;
            color: ${getColor("text.accent")};
            &:hover {
                background: ${getColor("primary")};
            }
            > span {
                &:last-child {
                    color: ${getColor("primary")};
                    position: absolute;
                    top: 5px;
                    left: 10px;
                    height: 18px;
                    width: 18px;
                }
            }
        }
    `,
};
